import './index.scss'
import {useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import {DateRange as DR} from 'react-date-range'
import {DateIcon} from '../../../icons'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'
import classNames from 'classnames'
import TimePicker from 'rc-time-picker'

const DateRange = ({
    placeholder,
    state,
    onChange,
    className,
    children,
    hasTimePicker = false,
    startTime,
    endTime,
    onChangeStartTime,
    onChangeEndTime
}) => {
    const rangeSelected = useSelector(state => state.monitoring.rangeSelected)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const [isActive, setIsActive] = useState(false)
    const ref = useRef()
    useOutsideClick(ref, () => setIsActive(false))

    const handleChange = item => {
        onChange([item.selection])
    }

    return (
        <div ref={ref}
            className={classNames('date-range', {
                'dark': isDarkMode,
                [className]: !!className,
                'active': isActive,
                'range-selected': rangeSelected
            })}
            onClick={() => setIsActive(!isActive)}>
            <p>{placeholder}</p>
            <span className="icon">
                <DateIcon/>
            </span>
            {isActive && (
                <div  className={classNames('date-range-box', {
                    'dark': isDarkMode,
                    'with-time-picker': hasTimePicker
                })} onClick={e => e.stopPropagation()}>
                    <div className='date-range-block'>
                        <DR
                            editableDateInputs={true}
                            onChange={item => handleChange(item)}
                            moveRangeOnFirstSelection={true}
                            scroll={{enabled: true}}
                            maxDate={new Date()}
                            ranges={state}
                            c/>
                        {hasTimePicker && <span className={classNames('time-picker-box', {
                            'dark': isDarkMode
                        })}>
                            <TimePicker
                                showSecond={false}
                                onChange={(value) => onChangeStartTime(value)}
                                clearIcon={<></>}
                                inputReadOnly
                                value={startTime}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                            />
                            <TimePicker
                                showSecond={false}
                                onChange={(value) => onChangeEndTime(value)}
                                clearIcon={<></>}
                                inputReadOnly
                                value={endTime}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                            />
                        </span>}
                    </div>
                    <div className="children">
                        {children}
                    </div>
                </div>
            )}
        </div>
    )
}

export default DateRange
